/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Product_Type_InvalidInputs */

const vi_error_shop_product_type_invalid = /** @type {(inputs: Error_Shop_Product_Type_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại sản phẩm không có trong danh sách hoặc bị chọn trùng.`)
};

/**

* @param {Error_Shop_Product_Type_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_product_type_invalid = /** @type {((inputs?: Error_Shop_Product_Type_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Product_Type_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_product_type_invalid(inputs)
});